import { PaymentType } from '../entities';
import { AccountingSystem } from '../entities/accounting/accounting.enums';

export enum AccountingSystemAction {

    // invoice prepayment
    CreatePrepayment = 'CreatePrepayment',

    // invoice payment
    CreatePayment = 'CreatePayment',
    DeletePayment = 'DeletePayment',

    // invoice credit refund
    CreateRefundPrepayment = 'CreateRefundPrepayment',
    DeleteRefundPrepayment = 'DeleteRefundPrepayment',

    CreateRefundCreditNote = 'CreateRefundCreditNote',
    DeleteRefundCreditNote = 'DeleteRefundCreditNote',

    // invoice allocation
    CreateInvoiceAllocation = 'CreateInvoiceAllocation',
    DeleteInvoiceAllocation = 'DeleteInvoiceAllocation',


}

export class AccountingSystemUtility {

    private static supportMap: Record<AccountingSystem, AccountingSystemAction[]> = {

        [AccountingSystem.Xero]: [

            AccountingSystemAction.CreatePrepayment,

            AccountingSystemAction.CreatePayment,
            AccountingSystemAction.DeletePayment,

            AccountingSystemAction.CreateRefundPrepayment,
            AccountingSystemAction.DeleteRefundPrepayment,

            AccountingSystemAction.CreateRefundCreditNote,
            AccountingSystemAction.DeleteRefundCreditNote,

            AccountingSystemAction.CreateInvoiceAllocation,
        ],

        [AccountingSystem.MYOB]: [

            AccountingSystemAction.CreatePrepayment,

            AccountingSystemAction.CreatePayment,
            AccountingSystemAction.DeletePayment,

            AccountingSystemAction.CreateRefundCreditNote,
            AccountingSystemAction.DeleteRefundCreditNote,

            AccountingSystemAction.CreateInvoiceAllocation,
            AccountingSystemAction.DeleteInvoiceAllocation,
        ],

        [AccountingSystem.QuickBooks]: [

            AccountingSystemAction.CreatePrepayment,

            AccountingSystemAction.CreatePayment,
            AccountingSystemAction.DeletePayment,

            AccountingSystemAction.CreateInvoiceAllocation,
            AccountingSystemAction.DeleteInvoiceAllocation,
        ],

        [AccountingSystem.Jobpac]: [],

        [AccountingSystem.Manual]: [],

    }


    public static isSupport(system: AccountingSystem, actions: AccountingSystemAction | Array<AccountingSystemAction>) {

        if (!system) return false;

        if (Array.isArray(actions)) {
            return actions?.every(action => this.supportMap[system]?.includes(action));
        }

        return this.supportMap[system]?.includes(actions);
    }


    public static getPaymentAction(type: PaymentType, action: 'create' | 'delete'): AccountingSystemAction {

        switch (type) {

            case PaymentType.Payable:
            case PaymentType.Receivable: {

                const map = {
                    ['create']: AccountingSystemAction.CreatePayment,
                    ['delete']: AccountingSystemAction.DeletePayment,
                }

                return map[action];
            }

            case PaymentType.PayableCredit:
            case PaymentType.ReceivableCredit: {

                const map = {
                    ['create']: AccountingSystemAction.CreateRefundCreditNote,
                    ['delete']: AccountingSystemAction.DeleteRefundCreditNote,
                }

                return map[action];
            }

            case PaymentType.PayablePrepayment:
            case PaymentType.ReceivablePrepayment: {
                const map = {
                    ['create']: AccountingSystemAction.CreateRefundPrepayment,
                    ['delete']: AccountingSystemAction.DeleteRefundPrepayment,
                }

                return map[action];
            }

            default:
                return null;
        }
    }


}